var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1601 22.6967C9.99039 22.6967 6.42834 22.0659 6.42834 19.5402C6.42834 17.0144 9.96722 14.8157 14.1601 14.8157C18.3297 14.8157 21.8918 16.9938 21.8918 19.5183C21.8918 22.0428 18.3529 22.6967 14.1601 22.6967Z",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.16 11.2144C16.8969 11.2144 19.1162 8.99631 19.1162 6.25945C19.1162 3.52258 16.8969 1.30322 14.16 1.30322C11.4231 1.30322 9.20376 3.52258 9.20376 6.25945C9.19605 8.98601 11.3974 11.2054 14.1252 11.2144H14.16Z",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3857 9.85352C23.9781 9.42741 25.1522 7.9753 25.1522 6.24642C25.1522 4.44287 23.8738 2.93669 22.172 2.58911",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1335 13.9122C25.3915 13.9122 27.3199 15.4429 27.3199 16.81C27.3199 17.6146 26.6544 18.4913 25.6451 18.7281",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93561 9.85352C4.34189 9.42741 3.16785 7.9753 3.16785 6.24642C3.16785 4.44287 4.44745 2.93669 6.14802 2.58911",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1864 13.9122C2.92842 13.9122 1 15.4429 1 16.81C1 17.6146 1.66555 18.4913 2.67611 18.7281",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/UsersIcon.341323452d5bbc4ad8a89b2e0e603496.svg";
export { ForwardRef as ReactComponent };